import { ADModalBody, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow, openWindow, WindowId } from "src/WindowManager/WindowState";
import { GlassInputControl, GlassInputControlLabel, GlassInputGroup, GlassInputGroupTitle } from "./GlassInput";
import { useContext, useEffect, useRef } from "react";
import { actionAddDataLayer, MapitStateContext } from "src/states/MapitState";
import { Persistence } from "src/managers/Persistence";
import { LayerInfo } from "src/common/managers/Types";
import { parse as WKTParse } from "wkt";
import { WFStoGeoJson } from "src/functions/WFSutils";
import { buildServitutDetailsParams } from "src/modules/ANNModule/ANNServitutIdentity";


export function OpslagsVindue({ window }: { window: ManagedWindow }) {
   const { dispatch: windowDispatch } = useWindowContext();
   const geoJsonInput = useRef<HTMLInputElement>(null);
   const wktStringInput = useRef<HTMLInputElement>(null);
   const { dispatch: mapitStateDispatch } = useContext(MapitStateContext);

   useEffect(() => {
      if (geoJsonInput.current) {
         let geojsonExamples = [
            '{"type": "FeatureCollection", "features": [....]}',
            '{"type": "Feature", "geometry": {....}}',
            '{"type": "MultiPolygon", "coordinates": [....]}',
            '{"type": "Polygon", "coordinates": [....]}',
            '{"type": "LineString", "coordinates": [....]}',
            '{"type": "MultiLineString", "coordinates": [....]}',
            '{"type": "Point", "coordinates": [....]}',
            '{"type": "MultiPoint", "coordinates": [....]}'
         ];
         let WktExamples = [
            'POINT(12.34 56.78)',
            'LINESTRING(30 10, 10 30, ...)',
            'POLYGON((30 10, 40 40, ...) ...)',

         ]
         function setExampleGeoJson() {
            if (geoJsonInput.current) {
               const example = geojsonExamples[Math.floor(Math.random() * geojsonExamples.length)];
               geoJsonInput.current.placeholder = example;
            }
            if (wktStringInput.current) {
               const example = WktExamples[Math.floor(Math.random() * WktExamples.length)];
               wktStringInput.current.placeholder = example;
            }
         }
         setExampleGeoJson();
         const interval = setInterval(setExampleGeoJson, 1000);
         return () => clearInterval(interval);

      }
   }, [geoJsonInput.current]);

   return (
      <AdvancedDragModal
         window={window}
         onClose={() => windowDispatch(closeWindow(window.id))}
         PosDefault={{ top: "50px", left: "25px" }}
         title="Opslag 🦖"
      >
         <ADModalInfo center >
            Udfyld linje og tryk Enter for at åbne detaljer i nyt vindue.
         </ADModalInfo>
         <ADModalBody>
            <GlassInputGroup>
               <GlassInputGroupTitle>Tinglysning</GlassInputGroupTitle>
               <GlassInputControlLabel>Adkomst</GlassInputControlLabel>
               <GlassInputControl><input placeholder="dokumentId" onKeyDown={(e) => {
                  if (e.key === "Enter") {
                     windowDispatch(openWindow(WindowId.AdkomstDetails, {
                        adkomst: {
                           dokumentId: (e.target as HTMLInputElement).value
                        }
                     }));
                  }
               }} /></GlassInputControl>
               <GlassInputControlLabel>Servitut</GlassInputControlLabel>
               <GlassInputControl><input placeholder="dokumentId" onKeyDown={(e) => {
                  if (e.key === "Enter") {
                     windowDispatch(openWindow(WindowId.ServitutDetails, buildServitutDetailsParams((e.target as HTMLInputElement).value)));
                  }
               }} /></GlassInputControl>
               <GlassInputGroupTitle>Geometrier</GlassInputGroupTitle>
               <GlassInputControlLabel>raw geojson (FC, F, G)</GlassInputControlLabel>
               <GlassInputControl><input ref={geoJsonInput} placeholder='{"type":"Feature","geometry":...}' onKeyDown={(e) => {
                  if (e.key === "Enter") {
                     try {
                        const geojson = JSON.parse((e.target as HTMLInputElement).value);
                        let validJson = {};
                        switch (geojson.type) {
                           case "FeatureCollection":
                              validJson = geojson;
                              break;
                           case "Feature":
                              validJson = { "type": "FeatureCollection", "features": [{ ...geojson, properties: { ...geojson.properties } }] };
                              break;
                           case "Point":
                           case "MultiPoint":
                           case "LineString":
                           case "MultiLineString":
                           case "Polygon":
                           case "MultiPolygon":
                              validJson = { "type": "FeatureCollection", "features": [{ "type": "Feature", "geometry": geojson, properties: {} }] };
                              break;
                           default:
                              throw new Error("Ugyldig geojson type. Understøttede typer: FeatureCollection, Feature, Point, MultiPoint, LineString, MultiLineString, Polygon, MultiPolygon");
                        }
                        Persistence.createLayersFromGeoJSON("From raw geojson", validJson, new Date(),
                           (li: LayerInfo) => { mapitStateDispatch(actionAddDataLayer(li, true)) }
                        );
                     } catch (error) {
                        alert("Fejl ved parsing af geojson: " + error);
                     }
                  }
               }} />
               </GlassInputControl>
               <GlassInputControlLabel>Well-known text (WKT)</GlassInputControlLabel>
               <GlassInputControl><input ref={wktStringInput} placeholder="POINT(12.34 56.78)" onKeyDown={(e) => {
                  if (e.key === "Enter") {
                     try {
                        const wktString = (e.target as HTMLInputElement).value;
                        const geojson = WKTParse(wktString);
                        const validJson = { "type": "FeatureCollection", "features": [{ "type": "Feature", "geometry": geojson, properties: {} }] };
                        Persistence.createLayersFromGeoJSON("From WKT", validJson, new Date(),
                           (li: LayerInfo) => { mapitStateDispatch(actionAddDataLayer(li, true)) }
                        );
                     } catch (error) {
                        alert("Fejl ved parsing af WKT: " + error);
                     }
                  }
               }} />
               </GlassInputControl>
               <GlassInputControlLabel>Geography Markup Language (GML)</GlassInputControlLabel>
               <GlassInputControl><input placeholder="? No Placeholder for gml" onKeyDown={(e) => {
                  if (e.key === "Enter") {
                     try {
                        const gmlString = (e.target as HTMLInputElement).value;
                        WFStoGeoJson(gmlString).forEach(({ layerName, geoJson }) => {
                           Persistence.createLayersFromGeoJSON(layerName ?? "GML data", geoJson, new Date(),
                              (li: LayerInfo) => { mapitStateDispatch(actionAddDataLayer(li, true)) }
                           );
                        });
                     } catch (error) {
                        alert("Fejl ved parsing af GML: " + error);
                     }
                  }
               }}
               /></GlassInputControl>

            </GlassInputGroup>

         </ADModalBody>
      </AdvancedDragModal>
   )
}